/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

export const FETCH_SDK_LANGUAGES_REQUEST = 'FETCH_SDK_LANGUAGES_REQUEST';
export const FETCH_SDK_LANGUAGES_SUCCESS = 'FETCH_SDK_LANGUAGES_SUCCESS';
export const FETCH_SDK_LANGUAGES_FAILURE = 'FETCH_SDK_LANGUAGES_FAILURE';

export interface SdkAction {
    type: typeof FETCH_SDK_LANGUAGES_REQUEST | typeof FETCH_SDK_LANGUAGES_SUCCESS | typeof FETCH_SDK_LANGUAGES_FAILURE
    payload?: string[] | string
}
